/**
 * noc-text-split.js
 * Split text into animated character spans — no library.
 * Usage: <h2 data-split>Titre</h2>
 * CSS drives the animation via --ci (char index) and data-state.
 *
 * Respects prefers-reduced-motion: skips splitting.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function split(el) {
    if (reduced) return;
    if (el.dataset.splitDone) return;
    var text = el.textContent;
    if (!text.trim()) return;

    el.setAttribute('aria-label', text);
    el.removeAttribute('aria-hidden');

    var html = '';
    var ci = 0;
    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      if (ch === ' ') {
        html += '<span class="noc-word-space"> </span>';
      } else if (ch === '\n') {
        html += '<br>';
      } else {
        html += '<span class="noc-char" style="--ci:' + ci + '" aria-hidden="true">' + ch + '</span>';
        ci++;
      }
    }
    el.innerHTML = html;
    el.dataset.splitDone = 'true';
  }

  function init() {
    document.querySelectorAll('[data-split]').forEach(split);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* Expose for dynamic content (e.g. View Transitions re-render) */
  window.NocSplit = { split: split, init: init };
}());
